import React, {useState, useEffect} from 'react';
import {FormattedMessage} from 'react-intl';

import Label from '../../Label';
import {SearchIcon, HistoryIcon} from '../../../styles/icons';
import Utility from '../../../utils/Helper';
import Config from '../../../utils/Configuration';
import {pagePath} from '../../../RouteConfig';

export default function SearchMenu({
    intl,
    showSearch,
    searchString,
    setShowSearch,
    getSearchResults,
    trendingSearches,
    searchPromotions,
    updateSearchString,
    getSuggestedSearches,
    lastSearch,
    screenName,
    navigate
}) {
    const [suggestedSearches, setSuggestedSearches] = useState([]);
    const [vWidth] = Utility.useWindowSize();

    let timeoutId;
    useEffect(() => {
        if (searchString.length >= 3) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            timeoutId = setTimeout(
                () => getSuggestedSearches(searchString).then((res) => setSuggestedSearches(res)),
                750
            );
            return () => clearTimeout(timeoutId);
        }
        return () => {};
    }, [searchString]);

    useEffect(() => {
        if (searchString.length >= 3) {
            getSuggestedSearches(searchString).then((res) => setSuggestedSearches(res));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const suggestions = lastSearch ? [{term: lastSearch}, ...suggestedSearches] : suggestedSearches;

    return (
        <div
            id='searchContainer'
            className={`container searchContainer w-100 ${showSearch ? 'active' : 'inactive'} p-0`}
        >
            <div id='searchMenu' className='w-100 searchMenu'>
                {searchString.length >= 3 && suggestions && suggestions.length > 0 ? (
                    <div className='container px-0 pb-4'>
                        <Label
                            labelClass='maxis-semiBold fs-14 text-blue-green pb-2 mb-0 px-3 px-md-0 px-lg-40px'
                            labelData={intl.messages.suggestedSearches}
                        />
                        {suggestions.slice(0, 4).map((suggestion, index) => {
                            return (
                                <Label
                                    key={`${suggestion}-${index}`}
                                    parentClass='hover-bg-gray'
                                    labelClass='fs-14 py-1 mb-0 cursor-pointer d-flex align-items-center px-3 px-md-0 px-lg-40px'
                                    labelData={
                                        lastSearch && index === 0 ? (
                                            <>
                                                <span className='me-2 search-icon d-flex align-items-center'>
                                                    <HistoryIcon />
                                                </span>
                                                <span className='maxis-bold text-black'>{suggestion.term}</span>
                                            </>
                                        ) : (
                                            <>
                                                <span className='me-2 search-icon d-flex align-items-center'>
                                                    <SearchIcon />
                                                </span>
                                                <FormattedMessage
                                                    id={`${suggestion.term}-${index}`}
                                                    defaultMessage='{messages}'
                                                    values={{
                                                        messages: (
                                                            <>
                                                                <span className='maxis-bold text-black'>
                                                                    {suggestion.term.substring(0, searchString.length)}
                                                                </span>
                                                                <span className='maxis-semiBold text-gunmetal'>
                                                                    {suggestion.term.substring(searchString.length)}
                                                                </span>
                                                            </>
                                                        )
                                                    }}
                                                />
                                            </>
                                        )
                                    }
                                    clickEvent={() => {
                                        updateSearchString(suggestion.term);
                                        if (screenName !== Config.pageName.solrSR) {
                                            Utility.navigateTo(pagePath.solrSearchResultUrl, navigate);
                                        } else {
                                            getSearchResults(suggestion.term);
                                            setShowSearch(false);
                                        }
                                    }}
                                />
                            );
                        })}
                    </div>
                ) : (
                    <>
                        {trendingSearches.length > 0 && (
                            <div className='container trendingSearch px-3 px-md-0 px-lg-40px pb-4'>
                                <div className='trendingSearchLabel text-blue-green fs-14 maxis-semiBold'>
                                    {intl.messages.trendingSearchLabel}
                                </div>
                                <div className='trendingResults'>
                                    {trendingSearches &&
                                        trendingSearches.slice(0, 10).map((trend, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => {
                                                        updateSearchString(trend);
                                                        if (screenName !== Config.pageName.solrSR) {
                                                            Utility.navigateTo(pagePath.solrSearchResultUrl, navigate);
                                                        } else {
                                                            getSearchResults(trend);
                                                            setShowSearch(false);
                                                        }
                                                    }}
                                                    className='trendingResult text-gunmetal fs-14 maxis-semiBold cursor-pointer mr-2 mb-2'
                                                >
                                                    {trend}
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}

                        {searchPromotions.length > 0 && (
                            <div className='container promotionSearch px-3 px-md-0 px-lg-40px'>
                                <div className='text-blue-green fs-14 maxis-semiBold'>
                                    {intl.messages.promotionSearchLabel}
                                </div>
                                <div className='promotionResults d-flex'>
                                    {searchPromotions &&
                                        searchPromotions.slice(0, vWidth < 768 ? 2 : 3).map((promo, index) => {
                                            return (
                                                <div className='position-relative' key={index}>
                                                    <div
                                                        className={`promotionResult cursor-pointer mb-4 ${
                                                            index === 2 ? 'mr-2' : ''
                                                        }`}
                                                        onClick={() => {
                                                            window.open(promo.id, '_blank');
                                                        }}
                                                        style={{backgroundImage: `url(${promo.imagePath})`}}
                                                    >
                                                        <div className='promotionTitle lh-normal text-gunmetal fs-18 maxis-bold line-clamp-1'>
                                                            {promo.title}
                                                        </div>
                                                        <div className='promotionDesc lh-normal text-gunmetal fs-14 maxis line-clamp-2'>
                                                            {promo.description}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
